import StaticRegister from '@utils/static_register.js'

const { register, getItem } = new StaticRegister('renderers')

export function _register(name, renderer) {
  register(name, renderer)
}

function proxyGetItem(name) {
  return getItem(name)
}

function proxyRegister(name, renderer) {
  if (typeof name !== 'string') {
    renderer = name
    name = renderer.RENDERER_TYPE
  }
  register(name, renderer)
}

export { proxyRegister as registerRenderer, proxyGetItem as getRenderer }
